module.exports = __webpack_public_path__ + "static/media/cq_convalida.0607146a.svg";